const logLevels = {
    runTimeError: 1,
    info: 2,
    debug: 3,
    syntaxError: 4,
    phrase: 5
};

export default logLevels;